import styled from "styled-components";

import { InfoPanel } from "../../../components/Panel/src/InfoPanel";
import { useTranslation } from "../../../components/WithTranslation/src/I18n";

import { Flex } from "./StyledComponents";

export const BoldSpan = styled.span`
    font-weight: 500;
`;

const StyledInfoPanel = styled(InfoPanel)`
    padding: 24px 16px;
`;
export const LeadingFoldersInfoPanelInProgress = () => {
    const translate = useTranslation();

    return (
        <StyledInfoPanel>
            <Flex>
                <BoldSpan>{translate("website.analysis.leading.folders.info.panel.inprogress.part.a")}</BoldSpan>
                <span>{translate("website.analysis.leading.folders.info.panel.inprogress.part.b")}</span>
            </Flex>
        </StyledInfoPanel>
    );
};
